import React from 'react';
import { Form, Header, Message, Button, Icon } from 'semantic-ui-react';
import { buildObjectsArr } from '../../helper/helper.js';
import admHOC from './admHOC.js';

class AdmFormHowTo extends React.Component {

  render() {

    const { formValues, formFieldValidity, submitAttempted, keyEditable } = this.props;
    const disableButtons = this.props.processing || !formFieldValidity._form || !formValues.key;
    const timestamp = Date.now();
    const humanTimestamp = new Date(parseInt(formValues.added,10))

    const actions = buildObjectsArr(this.props.actions);
    const optnActions = actions.map( acy =>  {
      const chanName = this.props.channels[acy.chanId]['name'] || 'DELETED';
      return {
        key: acy.key,
        text:`${chanName}: ${acy.name}`, 
        value: acy.key}
    });

    const fanoutObj = {
      parentPath: 'actions',
      child: formValues.actionId,
      endpoint: 'howToIds',
      data: formValues.key
    };

    const fanoutTimeStampObj = {
      parentPath: 'actions',
      child: formValues.actionId,
      endpoint: 'lastUpdated',
      data: timestamp
    };

    return (
      <Form as='form'
        error={!formFieldValidity._form}
        onReset={this.props.handleReset}
        onSubmit={ (e) => {
          // passing in an fanoutObj Array will
          this.props.handleSubmit('howtos', e, [fanoutObj, fanoutTimeStampObj]);
        }}>
        <Header dividing>
          <Icon name='comments'/>
          <Header.Content>How Tos</Header.Content>
          <Header.Subheader>Add, Edit or Delete</Header.Subheader>
        </Header>

        <Form.Input required name='key' label='Key'
          readOnly={!keyEditable}
          onChange={this.props.handleChange}
          error={!formFieldValidity.key && submitAttempted}
          value={formValues.key}
          placeholder='Key required, please choose on the left or click "add new"'
        />

        <Form.Select search required
          label='Action' name='actionId' placeholder='Action...'
          options={optnActions}
          value={formValues.actionId}
          onChange={this.props.handleChange}
        />

        <Form.Input required name='headline' label='Headline'
          onChange={this.props.handleChange}
          error={!formFieldValidity.headline && submitAttempted}
          value={formValues.headline}
        />

        <Form.TextArea required name='excerpt'
          label='Excerpt or Preview'
          onChange={this.props.handleChange}
          error={!formFieldValidity.excerpt && submitAttempted}
          value={formValues.excerpt}
        />

        <Form.Input required name='link' label='Link'
          type='url'
          onChange={this.props.handleChange}
          error={!formFieldValidity.link && submitAttempted}
          value={formValues.link}
        />

        <Form.Group className='formGroup'>
          <Form.Input required name='added' label='Added (timestamp)' width={5}
            ref={(input) => this.added = input}
            type='number'
            error={!formFieldValidity.added && submitAttempted}
            onChange={this.props.handleChange}
            value={formValues.added}
          />
          <Button className='formInlineBtn'
            type='button'
            icon='clock'
            onClick={(e) => this.props.handleChange(e, {name:'added', value:Date.now()}) } />
          <Form.Input readOnly name='added' label='Added (in humanoid)'
            icon='info'
            width={9}
            error={!formFieldValidity.added && submitAttempted}
            value={humanTimestamp}
          />
        </Form.Group>

        <Form.Input required name='score' label='Score'
          onChange={this.props.handleChange}
          error={!formFieldValidity.score && submitAttempted}
          value={formValues.score}
        />

        <Message error className='formMsg'>
          <Message.Header>You shall not pass!</Message.Header>
          <Message.List items={formFieldValidity._msgList} />
        </Message>

        <Button color='red' icon='trash' basic
          type='button'
          disabled={disableButtons}
          onClick={ (e) => this.props.confirmDeletion('howtos', e, [], [fanoutObj, fanoutTimeStampObj]) }
        />

        <Button.Group >
          <Button
            basic
            color='grey'
            type='reset'>
            Reset Form
          </Button>
          <Button
            primary
            disabled={disableButtons}
            type='submit'
            >
            Submit
          </Button>
        </Button.Group>

      </Form>
    );
  }

}

export default admHOC(AdmFormHowTo);



// WEBPACK FOOTER //
// ./src/components/forms/AdmFormHowTo.js